import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';

// Component for handling protected routes that require authentication
// or specific permissions to access
const PrivateRoute = ({ children, requiredPermission, adminOnly }) => {
  const { isAuthenticated, hasPermission, isClient, user } = useAuth();
  const location = useLocation();
  
  // If user is not authenticated, redirect to login page
  if (!isAuthenticated()) {
    // Redirect clients to customer login
    if (requiredPermission === 'is_client') {
      return <Navigate to="/customer-login" />;
    }
    // Redirect others to worker login
    return <Navigate to="/login" />;
  }
  
  // Special case for client routes
  if (requiredPermission === 'is_client') {
    if (user && (user.role === 'client' || user.isClient || hasPermission('is_client'))) {
      return children;
    } else {
      return <Navigate to="/login" />;
    }
  }
  
  // Block clients from accessing analytics and scan pages
  if (isClient() && (
    location.pathname.includes('/analytics') || 
    location.pathname.includes('/sex-ratio-analytics') || 
    location.pathname.includes('/scan')
  )) {
    return <Navigate to="/customer-dashboard" />;
  }
  
  // For admin-only routes
  if (adminOnly && !hasPermission('is_staff')) {
    return <Navigate to="/" />;
  }
  
  // If a specific permission is required and user doesn't have it
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/" />;
  }
  
  // User is authenticated and has the required permission (if any)
  return children;
};

export default PrivateRoute; 